<template>
    <div class="ma-4">
        <v-snackbar v-model="msg" top>
            {{ text }}
            <v-btn color="pink" text @click="msg = false">Close</v-btn>
        </v-snackbar>

        <ClientNav/>

        <v-row dense>
            <v-col cols="12" md="4" lg="3" xl="2">
                <ClientSide/>
            </v-col>

            <v-col cols="12" md="8" lg="9" xl="10">
                <v-card class="pa-2" outlined tile>
                    <v-tabs v-model="tab">
                        <v-tabs-slider color="yellow"></v-tabs-slider>
                        <v-tab v-for="(item, index) in items" :key="index" @click="activeTab = index">
                            {{ item }}
                            <v-chip class="ml-2" color="green" text-color="white" small>
                                {{ index === 0 ? activeDocsCount : expiredDocsCount }}
                            </v-chip>
                        </v-tab>
                    </v-tabs>

                    <v-tabs-items v-model="tab">
                        <v-tab-item v-for="(item, i) in items" :key="item">
                            <v-data-table
                                :headers="headers"
                                :items="i === 0 ? docs : expired"
                                sort-by="DateIssued"
                                sort-desc
                                :loading="isLoading"
                                loading-text="Loading Annual Documents"
                                :search="search"
                            >
                                <template v-slot:top>
                                    <v-toolbar flat color="white">
                                        <v-toolbar-title>Annual Documents</v-toolbar-title>
                                        <v-divider class="mx-4" inset vertical></v-divider>
                                        <v-spacer></v-spacer>

                                        <v-text-field
                                            v-model="search"
                                            clearable
                                            flat
                                            solo-inverted
                                            hide-details
                                            prepend-inner-icon="search"
                                            label="Search"
                                            class="hidden-sm-and-down"
                                        ></v-text-field>

                                        <v-text-field
                                            v-model="search"
                                            clearable
                                            flat
                                            solo-inverted
                                            hide-details
                                            prepend-inner-icon="search"
                                            label="Search"
                                            class="hidden-md-and-up ml-5 mr-5 mb-3 mt-3"
                                        ></v-text-field>
                                        <v-spacer></v-spacer>
                                        <v-btn color="#2b3990" dark @click="showAdd()">
                                            <v-icon left>add</v-icon>
                                            <span class="hidden-sm-and-down">Add Document</span>
                                            <span class="hidden-md-and-up">Add</span>
                                        </v-btn>
                                        <v-btn class="primary ml-3" @click="printTable()">
                                            <v-icon small>print</v-icon>
                                            <span class="hidden-sm-and-down">Print</span>
                                        </v-btn>
                                    </v-toolbar>
                                </template>

                                <template v-slot:item.actions="{ item }">
                                    <v-icon small class="mr-2 hidden-sm-and-down" @click="viewDoc(item, i)">
                                        mdi-eye
                                    </v-icon>
                                    <v-btn outlined medium class="mr-4 hidden-md-and-up" color="light-blue darken-4" @click="viewDoc(item)">
                                        view
                                    </v-btn>
                                    <v-icon small class="hidden-sm-and-down" @click="deleteDoc(item)" v-if="!directCare">
                                        mdi-delete
                                    </v-icon>
                                    <v-btn medium outlined class="hidden-md-and-up red--text" @click="deleteDoc(item)" v-if="!directCare">
                                        delete
                                    </v-btn>
                                </template>

                                <template v-slot:no-data>
                                    <v-btn color="#2b3990" class="white--text" @click="getDocs()">Reset</v-btn>
                                </template>
                            </v-data-table>
                        </v-tab-item>
                    </v-tabs-items>
                </v-card>
            </v-col>
        </v-row>
        <Foot class="hideOnPrint"/>

        <report-table
            :reportHeaderText="reportHeaderText"
            :tableHeaders="reportTableHeader"
            :tableData="reportData"
        />
    </div>
</template>

<script>
import axios from 'axios'
import ClientNav from '../../components/ClientNav'
import ClientSide from '../../components/ClientSide'
import Foot from '../../components/Footer'
import moment from 'moment'
import fileRenamer from '../../mixins/fileRenamer';
import ReportTable from '@/components/Report/ReportTable.vue';

const url = require("../../client_config/config").url;

export default {
    mixins: [fileRenamer],
    components: {
        ClientNav,
        ClientSide,
        Foot,
        ReportTable
    },
    data: function () {
        return {
            headers: [
                {
                    text: 'Document Type',
                    align: 'start',
                    sortable: false,
                    value: 'Type',
                },
                {text: "Mandatory", value: "Mandatory"},
                {text: "Elective", value: "Elective"},
                {text: "Date Issued", value: "DateIssued"},
                {text: "Date Expires", value: "DateExpires"},
                {text: "Actions", value: "actions", sortable: false},
            ],
            tab: null,
            items: ["Active Documents", "Expired Documents"],
            date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
            clientID: this.$route.params.clientID,
            docID: "",
            readonly: false,
            directCare: false,
            isLoading: true,
            search: "",
            selectedProgram: '',
            programs: [],
            msg: '',
            tempData: [],
            text: '',
            docs: [],
            expired: [],
            activeTab: 0
        };
    },

    computed: {
        clientName() {
            // `this` points to the component instance
            return this.$store.state.clients.client.Name;
        },
        activeDocsCount() {
            return this.docs.length;
        },
        expiredDocsCount() {
            return this.expired.length;
        }
        ,

        reportHeaderText() {
            return this.activeTab == 0 ? ' Active Documents': ' Expired Documents';
        },
        reportData() {
            return this.activeTab == 0 ? this.docs : this.expired;
        },
        reportTableHeader() {
            return this.headers.slice(0, this.headers.length-1);
        }
    },

    watch: {},

    created() {
        this.getDocs();
        this.getUnits();
        if (localStorage.getItem('userRole') === 'Direct Care Staff' ||
            localStorage.getItem('userRole') === 'Shift Lead' ||
            localStorage.getItem('userRole') === 'Assistant Manager' ||
            localStorage.getItem('userRole') === 'House Manager'
        ) {
            this.directCare = true;
            this.readonly = true;
        }
    },

    methods: {
        initialize() {
            this.docs = [];
        },
        viewDoc(item, index) {

            let isActive = index === 0;

            console.log({isActive})

            this.$router.push({
                path: `/annualDocs/${this.clientID}/update/${item._id}`,
                query: {newAnnualDocument: false, active: isActive}
            })
        },

        showAdd() {

            this.$router.push({
                path: `/annualDocs/${this.clientID}/new`,
                query: {newAnnualDocument: true}
            })
        },

        deleteDoc(item) {
            const id = item._id;
            confirm("Are you sure you want to delete this annual document?") &&
            this.docDelete(id);
            this.isLoading = true;
        },

        docDelete(id) {
            axios.delete(`${url}/annualDocs/${id}`)
                .then((response) => {
                    this.getDocs();
                    if (response.status === 400) {
                        response.json().then(function (data) {
                            return data.msg;
                        });
                    }
                    this.msg = true;
                    this.text = "The annual document has been deleted successfully.";
                });
        },

        getDocs() {
            this.isLoading = true;
            this.expired = [];
            this.docs = [];

            axios.get(`${url}/annualDocs/client/${this.clientID}?program=${this.selectedProgram}`).then(res => {
                let tempData = []
                tempData = res.data.docs;

                let today = moment(new Date()).format("YYYY-MM-DD")

                for (let i = 0; i < tempData.length; i++) {
                    let expiration = moment(tempData[i].DateExpires).format("YYYY-MM-DD")
                    if (moment(expiration).isBefore(today)) {
                        this.expired.push((tempData[i]))

                    } else {
                        this.docs.push(tempData[i])

                    }
                }
            }).finally(() => this.isLoading = false);
        },

        getUnits() {
            axios.get(`${url}/units`).then(async res => {
                this.programs = res.data.units;
            });
        },
        getCodes: function () {
            axios.get(`${url}/codes`).then(async res => {
                this.codes = res.data.codes;

            });
        },

        deleteChip(index) {
            // Prompt here with text if required
            this.newDocuments.splice(index, 1)
            //this.files = this.previousFiles
        },

        updateFields() {
            if (this.newType == 'Mandatory') {
                this.mandatoryPicked = true
                this.electivePicked = false
            } else if (this.newType == 'Elective') {
                this.electivePicked = true
                this.mandatoryPicked = false
            }
        },

        printTable() {
            document.getElementById('printTable').style.display = "block";
            window.print()
            document.getElementById('printTable').style.display = "none";
        }

    },
}
</script>

<style>
#printTable{
    display: none;
}

.btn-program {
    margin-top: 30px;
}

@media only screen and (min-width: 768px) {
    .mobile {
        display: none;
    }
}

@media only screen and (max-width: 600px) {
    .desktop {
        display: none;
    }

}
@media print {
    #printTable {
      display: block;
      border: none;
      width: 1200px;
      padding-right: 300px;
      margin-left: -200px;
    }

    .hideOnPrint {
      display: none;
      border: none;
    }

    nav.v-navigation-drawer, header.v-toolbar, button.v-btn, div.v-card {
      display: none;
      border: none;

    }

    @page { margin: 0; }
    body { margin: 1.6cm; }
  }
</style>
